import React, { useContext, useState, useEffect } from 'react';
import { DatePicker } from '@one-thd/sui-date-pickers';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { formatToMDY2Digits } from '../../../utils/formatters';

const CreateJobPostingDatePicker = ({ isCreateJobPosting = true }) => {
  const { editedJobPosting, updateJobPostingField } = useContext(JobPostingContext);
  const [dateStatus, setDateStatus] = useState({ status: '', statusMessage: '' });
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <= 639);

  const today = new Date();

  const dateConvert = (dateObj) => {
    if (!(dateObj instanceof Date)) return '';
    const yyyy = dateObj.getFullYear();
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
    const dd = String(dateObj.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const isValidDate = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regex)) return false;
    const date = new Date(dateString);
    const timestamp = date.getTime();
    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) return false;
    return date.toISOString().startsWith(dateString);
  };

  const handleDateChange = (dateInput) => {
    if (!dateInput || dateInput.length === 0) {
      setDateStatus({ status: '', statusMessage: '' });
      updateJobPostingField('deadlineToApply', null);
      return;
    }

    const date = new Date(dateInput);
    const convertedDate = dateConvert(date);

    if (dateInput.length < 10 || convertedDate <= dateConvert(today)) {
      setDateStatus({
        status: 'error',
        statusMessage: 'Please select a future date or leave blank.'
      });
    } else if (!isValidDate(convertedDate)) {
      setDateStatus({ status: 'error', statusMessage: 'Please select a valid Date.' });
    } else {
      setDateStatus({ status: '', statusMessage: '' });
    }

    updateJobPostingField('deadlineToApply', convertedDate);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsCollapsed(window.innerWidth <= 639);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={isCreateJobPosting ? 'ptp-job-posting__expire-date' : ''}>
      <DatePicker
        optional
        collapsible={isCollapsed}
        defaultValue={
          editedJobPosting?.deadlineToApply
            ? new Date(editedJobPosting.deadlineToApply) <= today
              ? ''
              : formatToMDY2Digits(editedJobPosting.deadlineToApply)
            : ''
        }
        dateFieldProps={{
          label: <div className="p2p-field__label"><span>Expiration Date</span></div>,
          status: dateStatus.status,
          statusMessage: dateStatus.statusMessage
        }}
        calendarProps={{ minDate: today }}
        onChange={(event, dateInput) => { handleDateChange(dateInput); }}
      />
    </div>
  );
};

export default CreateJobPostingDatePicker;
